export function setupCompat(app) {
  app.mixin({
    beforeCreate() {
      this.isCompat = Boolean(process.env.VUE_APP_COMPAT);
    },
  });
}
